import { get, put } from './requests.js'

export const getEntity = async (entity, id) => get([entity, id])

export const getSchema = async (entity) => get([entity, 'schema'])

export const updateEntity = async (entity, id, payload) => put([entity, id], {}, payload)
